<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 34 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.25 13L1 18.9573L6.25 25"
      stroke="white"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M2 19H16" stroke="white" stroke-linecap="round" stroke-linejoin="bevel" />
    <path
      d="M10 13.5V9C10 8.44772 10.4477 8 11 8H31C31.5523 8 32 8.44772 32 9V29C32 29.5523 31.5523 30 31 30H11C10.4477 30 10 29.5523 10 29V24.5"
      stroke="white"
    />
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: String,
      default: "34"
    },
    height: {
      type: String,
      default: "35"
    }
  }
};
</script>

<style lang="scss" scoped>
</style>